import { BonificoOrderStatus } from "../../ProductService/BonificoOrder/BonificoOrderDTO.ts";
import { BONIFICO_ORDER_STATUS_LABELS } from "./bonificoOrderStatusLabels.ts";

const STATUS_COLORS: Record<BonificoOrderStatus, string> = {
  [BonificoOrderStatus.Draft]:
    "bg-blue-100 text-blue-800 border border-blue-300",
  [BonificoOrderStatus.Discarded]:
    "bg-gray-100 text-gray-500 border border-gray-300",
  [BonificoOrderStatus.PendingPayment]:
    "bg-yellow-100 text-yellow-800 border border-yellow-300",
  [BonificoOrderStatus.ManuallyHandled]:
    "bg-purple-100 text-purple-800 border border-purple-300",
  [BonificoOrderStatus.PartiallyPaid]:
    "bg-cyan-100 text-cyan-800 border border-cyan-300",
  [BonificoOrderStatus.AwaitingInvoice]:
    "bg-indigo-100 text-indigo-800 border border-indigo-300",
  [BonificoOrderStatus.Paid]:
    "bg-green-100 text-green-800 border border-green-300",
  [BonificoOrderStatus.Historical]:
    "bg-slate-100 text-slate-700 border border-slate-300",
  [BonificoOrderStatus.Refunded]:
    "bg-gray-100 text-gray-700 border border-gray-300",
  [BonificoOrderStatus.PartiallyRefunded]:
    "bg-orange-100 text-orange-800 border border-orange-300",
};

export function BonificoOrderStatusBadge({
  status,
}: {
  status: BonificoOrderStatus;
}) {
  return (
    <span
      className={`px-2 py-1 rounded-full text-xs font-medium whitespace-nowrap ${STATUS_COLORS[status]}`}
    >
      {BONIFICO_ORDER_STATUS_LABELS[status]}
    </span>
  );
}
